import { render, staticRenderFns } from "./ProductCarouselCard.vue?vue&type=template&id=40c90054&scoped=true"
import script from "./ProductCarouselCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductCarouselCard.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ProductCarouselCard.vue?vue&type=style&index=0&id=40c90054&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c90054",
  null
  
)

export default component.exports